import { breadcrumbsAccessibility } from './breadcrumbs';

const accessibility = {
  initialize() {
    breadcrumbsAccessibility();
  }
}

export default accessibility;